<template>
  <footer class="navigation-footer">
    <article class="navigation-footer__section">
      <section class="navigation-footer__content">
        <div v-for="group in navGroups" :key="group.heading" class="navigation-footer__list">
          <h4 class="navigation-footer__heading">{{ group.heading }}</h4>

          <template v-for="link in group.links">
            <RouterLink
              v-if="link.route"
              :key="link.label"
              :to="link.route"
              class="navigation-footer__item"
              @click.native="onClickLink(link.route)"
            >
              {{ link.label }}
            </RouterLink>

            <a
              v-else-if="link.url"
              :key="link.label"
              :href="link.url"
              class="navigation-footer__item"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ link.label }}
            </a>
          </template>
        </div>

        <div class="navigation-footer__list">
          <h4 class="navigation-footer__heading">Coordonnées</h4>

          <p class="navigation-footer__item">
            5000, d'Iberville, bureau 304
            <br />
            Montréal (Québec) H2H 2S6
          </p>

          <a href="mailto:info@icea.qc.ca" class="navigation-footer__item">info@icea.qc.ca</a>
          <a href="tel:5149482044" class="navigation-footer__item">(514) 948-2044</a>
        </div>
      </section>

      <section class="navigation-footer__bottom -top">
        <p class="navigation-footer__copyright">
          Vous ne trouvez pas ce que vous cherchez?
          <RouterLink :to="{ name: 'search' }" @click.native="onClickLink({ name: 'search' })">
            Effectuez une recherche
          </RouterLink>
        </p>

        <div class="navigation-footer__row">
          <RouterLink
            :to="{ name: 'accessibility' }"
            class="navigation-footer__bottom-item"
            @click.native="onClickLink({ name: 'accessibility' })"
          >
            Accessibilité
          </RouterLink>
          <RouterLink
            :to="{ name: 'policy' }"
            class="navigation-footer__bottom-item"
            @click.native="onClickLink({ name: 'policy' })"
          >
            Politique de confidentialité
          </RouterLink>
          <RouterLink
            :to="{ name: 'writing' }"
            class="navigation-footer__bottom-item"
            @click.native="onClickLink({ name: 'writing' })"
          >
            Politique de rédaction inclusive
          </RouterLink>
        </div>
      </section>
    </article>

    <article class="navigation-footer__section -alt navigation-footer__bottom">
      <p class="navigation-footer__copyright">
        {{ currentYear }} &copy; Institut de coopération pour l'éducation des adultes
      </p>

      <div class="navigation-footer__row">
        <img src="/images/brand/QUEBEC_blanc.svg" alt="Logo gouvernement du Quebec" class="navigation-footer__logo" />
        <img
          src="/images/brand/fondation_blanc.png"
          alt="Fondation Lucie et André Chagnon"
          class="navigation-footer__logo"
        />
      </div>
    </article>
  </footer>
</template>

<script>
export default {
  name: 'NavigationFooter',
  data() {
    return {
      currentYear: new Date().getFullYear(),
      navGroups: [
        {
          heading: 'Informations',
          links: [
            { route: { name: 'home' }, label: 'Accueil' },
            { route: { name: 'about' }, label: 'À propos' },
            { route: { name: 'project-index' }, label: 'Projets' },
            { route: { name: 'events' }, label: 'Événements' },
            { route: { name: 'resources-index' }, label: 'Outils' }
          ]
        },
        {
          heading: 'Publications',
          links: [
            { route: { name: 'news-index' }, label: 'Nouvelles' },
            { route: { name: 'publication-index' }, label: 'Publications' },
            { url: 'https://icea-apprendreagir.ca/', label: 'Revue Apprendre + Agir' }
          ]
        },
        {
          heading: 'Nous soutenir',
          links: [
            { route: { name: 'donation' }, label: 'Faire un don' },
            { route: { name: 'about-members-register' }, label: 'Devenir membre' },
            { route: { name: 'partners' }, label: 'Partenaires financiers' },
            { route: { name: 'credits' }, label: 'Crédits' }
          ]
        }
      ]
    }
  },
  methods: {
    onClickLink(route) {
      if (route.name === this.$route.name) this.$scroll.toTop()
    }
  }
}
</script>
